import React, { createContext, useMemo } from 'react';

import StyledModal from '../../components/StyledModal/StyledModal';
import useModal from '../../hooks/useModal/useModal';
import { IModalContext } from '../../interfaces/modal';

const contextDefaultValues: IModalContext = {
  modal: false,
  modalContent: {},
  loading: false,
  handleOpenModal: () => {
    return;
  },
  handleCloseModal: () => {
    return;
  },
  handleLoadingModal: () => {
    return;
  }
};

export const ModalContext = createContext<IModalContext>(contextDefaultValues);

const ModalContextProvider = ({ children }: React.PropsWithChildren) => {
  const { modal, modalContent, loading, handleOpenModal, handleCloseModal, handleLoadingModal } = useModal();

  const value = useMemo(
    () => ({ modal, modalContent, loading, handleOpenModal, handleCloseModal, handleLoadingModal }),
    [modal, modalContent, loading, handleOpenModal, handleCloseModal, handleLoadingModal]
  );

  return (
    <ModalContext.Provider value={value}>
      <StyledModal />
      {children}
    </ModalContext.Provider>
  );
};

export default ModalContextProvider;
